import styled, { css } from 'styled-components'

export const HiddenInput = styled.input`
  display: none;
`

export const NavbarWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['12']};
  `,
)

export const ButtonsWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.space['16']};
  `,
)
